import dayjs from "dayjs";

export const formatDate = (dateString: string): string => {
  const date = dayjs(dateString);
  return date.format("MM/DD/YYYY");
};

export const formatDateTime = (dateString: string): string => {
  const date = dayjs(dateString);
  return date.format("MM/DD/YYYY h:mm A");
};

export const formatDob = (dateString: string): string => {
  if (!dateString || dateString === "-") {
    return dateString || "-";
  }
  const date = dayjs(dateString);
  return date.format("MM/DD/YYYY");
};

export const calculateDaysUntilAppointment = (
  appointmentDatetime: string,
): number => {
  const appointmentDate = new Date(appointmentDatetime);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  appointmentDate.setHours(0, 0, 0, 0);

  const timeDiff = appointmentDate.getTime() - today.getTime();
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
};

export const formatDaysUntilAppointment = (daysUntil: number): string => {
  if (daysUntil === 0) {
    return "Today";
  }
  if (daysUntil === 1) {
    return "Tomorrow";
  }
  if (daysUntil === -1) {
    return "Yesterday";
  }
  if (daysUntil > 1) {
    return `in ${daysUntil} days`;
  }
  return `${Math.abs(daysUntil)} days ago`;
};
